<template>
  <div class="image-card flex flex-align-center bg-FFFFFF">
    <img :src="row.ad_image_url" :class="{'w1h1': row.rate === 1, 'w16h9': row.rate === 2}"
         class="img border-radius-4px bg-F2F5F7"/>
    <div class="info-panel flex-1 text-align-left pl-8 pr-8" :class="{'w1h1': row.rate === 1, 'w16h9': row.rate === 2}">
      <p class="title font-size-14 pt-4 font-weight-600 c-333 text-overflow-ellipsis-1">{{ row.ad_title }}</p>
      <p class="desc font-size-12 c-C0C0C0 text-overflow-ellipsis-1">{{ row.ad_description }}</p>
    </div>
    <p class="btn border-radius-4px">{{ row.ad_button }}</p>
    <p class="more font-weight-bolder c-C0C0C0">...</p>
  </div>
</template>
<script>
export default {
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang="less">
.image-card {
  margin-top: 8px;
  margin-bottom: 8px;
  box-sizing: border-box;
  width: 370px;
  height: 60px;
  padding: 6px;
  border: 1px solid #e4e4e4;

  .img {
    background-color: #C0C0C0;

    &.w1h1 {
      height: 45px;
      width: 45px;
    }

    &.w16h9 {
      width: 80px;
      height: 45px;
    }
  }

  .info-panel {
    height: 100%;

    &.w1h1 {
      .title, .desc {
        width: 210px;
      }
    }

    &.w16h9 {
      .title, .desc {
        width: 175px;
      }
    }
  }

  .btn {
    width: 60px;
    border: 1px solid #fed2df;
    color: #fc90af;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .more {
    width: 25px;
    writing-mode: vertical-rl; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
    //writing-mode: tb-lr;/*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
    text-align: center;
  }
}
</style>
